var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrafficOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13C6.77614 13 7 13.2239 7 13.5V20.5C7 20.7761 6.77614 21 6.5 21H3.5C3.22386 21 3 20.7761 3 20.5V13.5C3 13.2239 3.22386 13 3.5 13H6.5Z",
    fill: "#42A059"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7C13.7761 7 14 7.22386 14 7.5V20.5C14 20.7761 13.7761 21 13.5 21H10.5C10.2239 21 10 20.7761 10 20.5V7.5C10 7.22386 10.2239 7 10.5 7H13.5Z",
    fill: "#42A059"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 3C20.7761 3 21 3.22386 21 3.5V20.5C21 20.7761 20.7761 21 20.5 21H17.5C17.2239 21 17 20.7761 17 20.5V3.5C17 3.22386 17.2239 3 17.5 3H20.5Z",
    fill: "#42A059"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficOk);
export default __webpack_public_path__ + "static/media/traffic_ok.735e27ef40f5c7b49d9defafd94e1fe3.svg";
export { ForwardRef as ReactComponent };